import $ from "jquery";
import Em from "./Em";

class Header extends Em {
    constructor() {
        super();
        this.init(); 
    }

    init() {
        this.selfDom();
        this.getScrollbarWidth();
        this.events();
    }

    selfDom() {
        this.$headerNavToggle = $('#header-nav-toggle');
    }
    
    getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    events() {
        // nav toggle click
        this.$headerNavToggle.off('click.Header');
        this.$headerNavToggle.on('click.Header', this.navToggleHandler.bind(this));

        // close nav on resize
        this.$window.on('resize.Header', () => {
            if (this.$body.hasClass('nav-is-active') && !this.isMobileNav()) {
                this.closeNav();
            }
        });
    }

    navToggleHandler(event) {
        event.preventDefault();

        if (!this.$body.hasClass('nav-is-active')) {
            this.openNav();
        } else {
            this.closeNav();
        }
    }

    openNav() {
        this.$header.css('padding-right', this.getScrollbarWidth());
        this.$body.addClass('nav-is-active');

        // If someone doesn't open the nav from the top of the page
        window.scrollTo(0, 0);

    }

    closeNav() {
        this.$header.css('padding-right', 0);
        this.$body.removeClass('nav-is-active');
    }

    isMobileNav() {
		return this.$header.find(this.$headerNavToggle).is(':visible');
	}
}

export default Header;
